import { HowToReachTier } from './HowToReachTier';
import { stripColorTags } from './utils/parseColoredText';
import type { ComponentCheck } from './hooks/useTierEvaluation';

interface TierInfo {
  tierId: string;
  name: string;
  detailSummary?: string;
  componentChecks?: ComponentCheck[];
}

interface NextTierInfo {
  tierId: string;
  name: string;
  earnRateDescription?: string;
  maxEarningsDescription?: string;
  componentChecks: ComponentCheck[];
}

interface TierDetailScreenProps {
  tierLoading: boolean;
  evaluatedTier: TierInfo | null;
  evaluatedNextTier: NextTierInfo | null;
  onBack: () => void;
}

export function TierDetailScreen({
  tierLoading,
  evaluatedTier,
  evaluatedNextTier,
  onBack,
}: TierDetailScreenProps) {
  if (tierLoading) return null;

  const currentName = evaluatedTier?.name ?? 'Tier 1';
  const currentSummary = evaluatedTier?.detailSummary ?? '';
  const isMaxTier = !evaluatedNextTier;

  if (isMaxTier) {
    return (
      <HowToReachTier
        currentTierName={currentName}
        currentTierId={evaluatedTier?.tierId}
        currentEarnSummary={currentSummary}
        targetTierName={currentName}
        targetTierId={evaluatedTier?.tierId}
        targetEarnSummary=""
        componentChecks={evaluatedTier?.componentChecks ?? []}
        onBack={onBack}
      />
    );
  }

  const targetName = evaluatedNextTier?.name ?? 'Tier 2';
  const targetRate = stripColorTags(evaluatedNextTier?.earnRateDescription);
  const targetMax = stripColorTags(evaluatedNextTier?.maxEarningsDescription);
  const targetSummary = [
    'Clear every check below',
    targetRate ? ` — ${targetRate.toLowerCase()}` : '',
    targetMax ? ` ${targetMax}` : '',
  ].join('');

  return (
    <HowToReachTier
      currentTierName={currentName}
      currentTierId={evaluatedTier?.tierId}
      currentEarnSummary={currentSummary}
      targetTierName={targetName}
      targetTierId={evaluatedNextTier?.tierId}
      targetEarnSummary={targetSummary}
      componentChecks={evaluatedNextTier?.componentChecks ?? []}
      onBack={onBack}
    />
  );
}
